import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import LevvyLogo from './LevvyLogo';
export const GetLevvyCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            LevvyCardTID: {
                Connect: 'levvy-card-connect'
            }
        }
    });
export default function LevvyCard() {
    const { t: levvyTexts } = useLocaleKeys('integrations.availableApps.levvy');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('levvy');
    const { LevvyCardTID } = useMemo(()=>GetLevvyCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "levvy-card",
        icon: /*#__PURE__*/ _jsx(LevvyLogo, {}),
        title: levvyTexts.title(),
        subTitle: levvyTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_levvy'
            },
            onClick: showCopyAPIKeyModal,
            testId: LevvyCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
